import { render } from "./CreateSeries.vue?vue&type=template&id=0b948e23&scoped=true"
import script from "./CreateSeries.vue?vue&type=script&lang=js"
export * from "./CreateSeries.vue?vue&type=script&lang=js"

import "./CreateSeries.vue?vue&type=style&index=0&id=0b948e23&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b948e23"]])

export default __exports__